import { showMessageBox } from '../msgbox.jsx';
import xhr from '../xhr.js';

export async function renderPreview(parser, text, purpose='forum') {
    if(typeof text !== 'string' || typeof parser !== 'string')
        return document.createTextNode('');

    const formData = new FormData;
    formData.append('purpose', purpose);
    formData.append('format', parser);
    formData.append('text', text);

    const { status, body } = await xhr.post('/_preview', { authed: true, csrf: true }, formData);

    switch(status) {
    case 200:
        const frag = <><span/></>;
        frag.firstChild.insertAdjacentHTML('afterend', body);
        frag.firstChild.remove();
        return frag;
    case 400:
        showMessageBox('Could not render preview because of a client error.');
        return document.createTextNode(text);
    case 413:
        showMessageBox('Your post is too long!');
        return document.createTextNode(text);
    case 415:
        showMessageBox('Unsupported parser selected!');
        return document.createTextNode(text);
    default:
        showMessageBox('Could not render preview because of an unknown error.');
        return document.createTextNode(text);
    }
}
